import React from 'react';
import Button from '@material-ui/core/Button';

export default function SelectShopButton(props) {
  const handleOnClick = () => props.onClick(props.shop, props.searchTerm);

  return (
    <Button id="selectShopButton" color="primary" onClick={handleOnClick}>
      Select
    </Button>
  );
}
